module.exports = __webpack_public_path__ + "img/popup-mlbb-id-74diamond.a49ffa4.png";